import axios from "axios";

const axiosObj = () => {
	const api = "https://elitemindmap.in/api";

	axios.defaults.withCredentials = true; // keep cookies if needed

	const axiosInstance = axios.create({
		baseURL: api,
		headers: {
			"Content-Type": "application/json",
		},
	});

	// Optional: Add request interceptor for logging or other headers
	axiosInstance.interceptors.request.use(
		(config) => {
			console.log(
				`Request ➤ ${config.method.toUpperCase()} ${config.url}`
			);
			return config;
		},
		(error) => {
			return Promise.reject(error);
		}
	);

	// Add response interceptor for global error handling
	axiosInstance.interceptors.response.use(
		(response) => response,
		(error) => {
			console.error("API Error:", error.response?.status, error.message);
			return Promise.reject(error);
		}
	);

	return axiosInstance;
};

export default axiosObj;
